<template>
   <main>
      <section>
         <div class="container pt-2 pb-4">
            <div class="row justify-content-between">

               <div class="col-12 col-md-6 mb-4">
                  <h2>Cerca</h2>
                     <searchArea 
                        :full="'full'" 
                        :where="'intro'"
                        :inactive="true"
                        :query.sync="this.$route.params.keywords"
                        :argomento.sync="this.argomento"
                        :tipologia.sync="this.tipologia"
                        :areaSpecializzazione.sync="this.areaSpecializzazione"
                        v-on:queryWatcher="setQuery($event)"
                        v-on:clearSearch="clearSearch()"
                        v-on:setPeriod="setPeriod($event)"
                        v-on:setSearched = "setSearched($event)"
                        v-on:setArgSelected = "setArgomento($event)"
                        v-on:setAreaSelected = "setArea($event)"
                        v-on:setTipoSelected = "setTipo($event)"
                        ref="searchArea"
                     />                     
               </div>
            </div>
         </div>
      </section>

      <section id="area-specializzazione" class="section section-inset-shadow pb-0 pt-2 pb-5">
         <div id="content" class="container pt-2 pb-4 px-0 px-md-3 pt-5">
            <div class="row">
               <!--div class="col-12 col-md-3">
                   <div class="panel mt-4" v-for="(item, key, index,) in facets" :key="index" :ref="`card_${index}`">
                  <div class="panel mt-4">
                     <div >
                     <facets 
                        :facetsResults="facetsResult" 
                        :facetWithResults="facetWithResults"
                        :facetSelected="facetSelected"                    
                        :argomentoSelected = "argomento"
                        v-on:listenSChanged = "setFacetSChanged($event)"
                        v-on:listenAreaChanged = "setFacetAreaChanged($event)"
                        v-on:listenArgsChanged = "setFacetArgsChanged($event)"
                     />          
                     </div>
                  </div>
               </div-->
               
               <div class="col-12" v-if="pager.totalResults > 0">
                  <div class="d-flex small align-items-center justify-content-between">
                     <div class="text-left">Trovati {{data.total.value}} risultati</div>
                     <div class="align-items-center d-flex">
                        <span>Ordina per </span>
                        <b-form-select class="form-control-sm small bordered ml-1" value-field="value" text-field="text" v-model="sortBy.selected" :options="sortBy.sorting" @change="changeSorting"/>
                     </div>                                  
                  </div>
                  <div class="row">
                     <!-- Call cards -->                                                            
                     <result v-for="(item, index) in data.hits" :news="{item}" :key="index" :ref="`card_${index}`"></result>
                  </div>
                  <pager :pager="pager" use-router v-if="pager.totalResults > 0" v-on:listenChangePage="changePage($event)" v-on:listenLimitChange="setLimit($event)"/>
               </div>
               <div class="col-12 "  v-if="data.total !== undefined && data.total.value === 0 && searched">
                  <div class="alert alert-danger m-4" v-cloak>
                     La ricerca di - <b>{{query}}</b> - non ha prodotto risultati in nessun risultato.
                  </div>
               </div>
            </div>
         </div>
      </section>   
   </main>
</template>

<script>
import axios from 'axios';
import searchArea from "@/components/SearchArea.vue"
import result from '@/components/Results';
import pager from '@/components/Pager';
//import facets from '@/components/Facets';

export default {
   name: "Ricerca",

   components: {
      result,
      searchArea,
     // facets,
      pager
   },
   data() {
      return {
         query: '',
         searched: false,
         pager:{
            currentPage: 1,
            totalResults: 0,
            from: 0,
            limit: 9
         },              
         sortBy:{
            selected: '_score',
            sorting: [
               { value: "_score", text: 'Rilevanza' },
               { value: {"data.titolo.iv.keyword": {"order" : "asc"}}, text: 'Titolo A-Z' },
               { value: {"data.titolo.iv.keyword": {"order" : "desc"}}, text: 'Titolo Z-A' },
               { value: {"created": {"order" : "asc"}}, text: 'Più recente' },
               { value: {"created": {"order" : "desc"}}, text: 'Meno recente' },
            ]
         },       
         sort:[{"_score": {"order":"desc"}}],
 
         /*********************
          * Argomenti selezionato tramite il filtro
          *********************/
         argomento: [],
         tipologia: [],
         areaSpecializzazione: [],
         filters: [],
         data: [],
 
         /*************************
          * Results from search
          *************************/
         facetsResult: []     
      }
   },
   mounted(){
      if(this.$route.query.q || this.$route.params.keywords != ''){
         this.query = this.$route.params.keywords != '' ? this.$route.params.keywords : this.$route.query.q;
      }
      if(this.$route.params.argomenti !== undefined && this.$route.params.argomenti.length > 0){
         this.argomento = this.$route.params.argomenti;
      }
      if(this.$route.params.areeSpecializzazione !== undefined && this.$route.params.areeSpecializzazione.length > 0){
         console.log('areeSpecializzazione');
         this.areaSpecializzazione = this.$route.params.areeSpecializzazione;
      }
      if(this.$route.params.tipologie !== undefined && this.$route.params.tipologie.length > 0){
         console.log('tipologie');
         this.tipologia = this.$route.params.tipologie;
      }

      this.search();    
   },
   methods: {
      changePage(value){
         this.pager.from = this.pager.limit * (value - 1);
         this.pager.currentPage = value;         
         this.search();
      },

      changeSorting(event) {
         if(event == '_score'){
            this.sort = [{"_score": {"order":"desc"}}];
         }
         else{         
            this.sort = event;
         }
         this.search();
      },

      checkSearch(val){
         if(val == 0 && this.query == ''){
            this.clearSearch();
         }
      },

      clearSearch(){         
         this.query = '';
         this.argomento = [];
         this.tipologia = [];
         this.areaSpecializzazione = [];
         this.filters = [];
         this.dal = this.al = null;
         this.setSearched(false);
         this.search();
      },

      getDates(dateToChange){
         const convDate = dateToChange.split('/');
         return convDate[2] + '-' + convDate[1] + '-' + convDate[0];
      },      

      setArea: function(arr){
         this.areaSpecializzazione = arr;
      },  
      setArgomento: function(arr){
         this.argomento = arr;
      },  
      setTipo: function(arr){
         this.tipologia = arr;
      },  

      setFilters(){           
         this.filters = [];
         if(this.argomento.length > 0){
            this.filters.push({terms : {"data.argomenti.iv.keyword": this.argomento }});            
         }
         if(this.tipologia.length > 0){
            this.filters.push({terms : {"name.keyword": this.tipologia }});
         }
         if(this.areaSpecializzazione.length > 0){
            this.filters.push({terms : {"data.areeSpecializzazione.iv.keyword": this.areaSpecializzazione }});
         }         
      },

      setLimit(value){
         this.pager.limit = value;
         this.search();
      },   

      setQuery(value){
         this.query = value;
         //if(this.query.length < 3 && this.argomento.length == 0){ return false; }
         this.search();
         this.setSearched(true);
      },

      setSearched: function(val){
         this.searched = val;
      },     

      search() {
         if(this.tipologia.length > 0 || this.argomento.length > 0 || this.areaSpecializzazione .length > 0){
            this.setFilters();
         }     
         else{
            this.filters = [];
         }    

         axios.post(process.env.VUE_APP_ESEARCH_PROTOCOL+process.env.VUE_APP_ESEARCH+'/'+process.env.VUE_APP_ESEARCH_INDEX+'/_search',
            {
               "size": this.pager.limit,
               "from" : this.pager.from,   
               "track_scores": true,
               "aggs": {
                "S3": {
                  "terms": {
                    "field": "data.s3.iv.keyword",
                    "size": 10
                  }
                },
                "Aree Specializzazione": {
                  "terms": {
                    "field": "data.areeSpecializzazione.iv.keyword",
                    "size": 10
                  }
                },
                "Argomenti": {
                  "terms": {
                    "field": "data.argomenti.iv.keyword",
                     "size": 10
                  }
                }
               },
               "sort" : this.sort,
               "query": {
                  "bool": {
                     "must": {
                        "simple_query_string": {
                           "query": this.query+'*',
                           "flags": "ALL",
                           "fuzzy_transpositions": true,
                           "fuzzy_max_expansions": 50,
                           "fuzzy_prefix_length": 0,
                           "minimum_should_match": 1,
                           "default_operator": "or",
                           "lenient": true,
                           "analyzer": "standard",
                           "quote_field_suffix": "",
                           "analyze_wildcard": true,
                           "auto_generate_synonyms_phrase_query": true,
                        }
                     },                    
                     "filter": this.filters
                  }
               }                  
            },              
            {
               auth: { 
                  username: process.env.VUE_APP_ESEARCH_CREDENTIALS_USER,
                  password: process.env.VUE_APP_ESEARCH_CREDENTIALS_PASS
               }
            }
         ).then(response => {
            this.data = response.data.hits;
            this.facetsResult = response.data.aggregations;
            this.pager.totalResults = response.data.hits.total.value;   
            //this.setFacetWithResultsAfterSearch(this.facetsResult);
         })
      }
   },

   watch: {
      currentPage: {
         handler: function() {
           this.fetchData().catch(error => {
             console.error(error)
           })
         }
      }
   }   
}

</script>
<style>
#filterTabs .nav-item .nav-link{ width:100%; }
input[type="search"]:placeholder-shown + .input-group-append > .reset { display: none;}
.input-group-append.reset{position:unset;}
.custom-select{ border:1px solid #CDCDCD}
[v-cloak] {
  display: none;
}
</style>